import isEqual from 'lodash/isEqual'
import { MagentoSortField } from 'lib/types'
import { CATALOG_SORT } from 'lib/core/resources/constants'

export interface SortOptionType {
  label: string
  value: [string, string]
}

export const getSortValue = (value: string[] = [], options: SortOptionType[] = []) => {
  return options.find((obj) => isEqual(obj.value, value))
}

export const getSortOptions = (sortOptions: MagentoSortField[] = []) => {
  const options: SortOptionType[] = []

  sortOptions?.forEach(option => {
    const { label, value } = option
    options.push({
      label: `${label} ↑`,
      value: [value, CATALOG_SORT.ASC]
    })
    options.push({
      label: `${label} ↓`,
      value: [value, CATALOG_SORT.DESC]
    })
  })

  return options
}
